import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import TeamCard from './TeamCard'
import './testimonial17.css'

/**
 * 团队展示组件
 * 重构后的组件使用可复用的TeamCard组件来减少代码重复
 */
const Team17 = (props) => {
  return (
    <div className={`thq-section-padding ${props.rootClassName} `}>
      <div className="testimonial17-max-width thq-section-max-width">
        {/* 标题部分 */}
        <div className="testimonial17-container10">
          <h2 className="thq-heading-2">
            {props.heading1 ?? (
              <Fragment>
                <span className="testimonial17-text40">Our Team</span>
              </Fragment>
            )}
          </h2>
          <span className="testimonial17-text11 thq-body-small">
            {props.content1 ?? (
              <Fragment>
                <span className="testimonial17-text41">
                  Meet the talented people behind Signbridge AI.
                </span>
              </Fragment>
            )}
          </span>
        </div>
        
        {/* 团队成员卡片网格 */}
        <div className="thq-card thq-grid-2">
          {/* 卡片1 */}
          <TeamCard 
            className="testimonial17-card1"
            authorAlt={props.author1Alt}
            authorSrc={props.author1Src}
            authorName={props.author1Name}
            authorPosition={props.author1Position}
            review={props.review1}
            defaultName="John Doe"
            defaultPosition="CEO, Tech Corp"
            defaultReview="Working with Signbridge AI has been a game-changer for our organization. Their AI-powered solutions have significantly improved accessibility for our employees and customers."
          />
          
          {/* 卡片2 */}
          <TeamCard 
            className="testimonial17-card2"
            imageClassName="testimonial17-image2"
            containerClassName="testimonial17-container14"
            infoContainerClassName="testimonial17-container15"
            textClassName="testimonial17-text17"
            authorAlt={props.author2Alt}
            authorSrc={props.author2Src}
            authorName={props.author2Name}
            authorPosition={props.author2Position}
            review={props.review2}
            defaultName="Jane Smith"
            defaultPosition="Director of Operations, GovTech"
            defaultReview="Signbridge AI's real-time sign language translation has transformed the way we communicate with our deaf and hard-of-hearing citizens. It's a remarkable innovation that is making a difference."
          />
          
          {/* 卡片3 */}
          <TeamCard 
            className="testimonial17-card3"
            imageClassName="testimonial17-image3"
            containerClassName="testimonial17-container16"
            infoContainerClassName="testimonial17-container17"
            textClassName="testimonial17-text20"
            authorAlt={props.author3Alt}
            authorSrc={props.author3Src}
            authorName={props.author3Name}
            authorPosition={props.author3Position}
            review={props.review3}
            defaultName="Michael Johnson"
            defaultPosition="Head of Innovation, Global Corp"
            defaultReview="We are proud to partner with Signbridge AI in breaking communication barriers. Their dedication to revolutionizing accessibility through AI technology is commendable."
          />
          
          {/* 卡片4 */}
          <TeamCard 
            className="testimonial17-card5"
            imageClassName="testimonial17-image5"
            containerClassName="testimonial17-container20"
            infoContainerClassName="testimonial17-container21"
            textClassName="testimonial17-text26"
            authorAlt={props.author4Alt3}
            authorSrc={props.author4Src3}
            authorName={props.author4Name3}
            authorPosition={props.author4Position3}
            review={props.review43}
            defaultName="Sarah Lee"
            defaultPosition="Accessibility Coordinator, City Council"
            defaultReview="Signbridge AI's AI agent has been instrumental in enhancing inclusivity within our community. Their commitment to empowering individuals through technology is truly inspiring."
          />
          
          {/* 卡片5 */}
          <TeamCard 
            className="testimonial17-card7"
            imageClassName="testimonial17-image7"
            containerClassName="testimonial17-container24"
            infoContainerClassName="testimonial17-container25"
            textClassName="testimonial17-text30"
            authorAlt={props.author7Alt}
            authorSrc={props.author7Src}
            authorName={props.author7Name}
            authorPosition={props.author7Position}
            review={props.review7}
            defaultName="Jace Pang"
            defaultPosition="Data Scientist"
            defaultReview="A Data Scientist for sign language generation, NEU Master's graduate, formerly at AWS and Home Depot."
          />
          
          {/* 卡片6 */}
          <TeamCard 
            className="testimonial17-card6"
            imageClassName="testimonial17-image6"
            containerClassName="testimonial17-container22"
            infoContainerClassName="testimonial17-container23"
            textClassName="testimonial17-text29"
            authorAlt={props.author4Alt2}
            authorSrc={props.author4Src2}
            authorName={props.author4Name2}
            authorPosition={props.author4Position2}
            review={props.review42}
            defaultName="Sarah Lee"
            defaultPosition="Accessibility Coordinator, City Council"
            defaultReview="Signbridge AI's AI agent has been instrumental in enhancing inclusivity within our community. Their commitment to empowering individuals through technology is truly inspiring."
          />
        </div>
      </div>
    </div>
  )
}

Team17.defaultProps = {
  author1Alt: 'Image of John Doe, CEO of Tech Corp',
  author4Name2: undefined,
  author4Src2:
    'https://images.unsplash.com/photo-1586297135537-94bc9ba060aa?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDMxfHxhdmF0YXJ8ZW58MHx8fHwxNzE2MzgzNTY2fDA&ixlib=rb-4.0.3&w=200',
  review3: undefined,
  author3Src:
    'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDEyfHxhdmF0YXJ8ZW58MHx8fHwxNzE2MzgzNTUyfDA&ixlib=rb-4.0.3&w=200',
  review1: undefined,
  author4Alt: 'Image of Sarah Lee, Accessibility Coordinator at City Council',
  author4Name: undefined,
  review2: undefined,
  review4: undefined,
  author3Alt: 'Image of Michael Johnson, Head of Innovation at Global Corp',
  author4Name3: undefined,
  author4Position2: undefined,
  author1Position: undefined,
  author1Name: undefined,
  author4Alt2: 'Image of Sarah Lee, Accessibility Coordinator at City Council',
  heading1: undefined,
  author4Alt3: 'Image of Sarah Lee, Accessibility Coordinator at City Council',
  content1: undefined,
  rootClassName: '',
  author3Position: undefined,
  author2Alt: 'Image of Jane Smith, Director of Operations at GovTech',
  author3Name: undefined,
  author4Position: undefined,
  review43: undefined,
  author1Src:
    'https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDN8fGF2YXRhcnxlbnwwfHx8fDE3MTYzODM1NTJ8MA&ixlib=rb-4.0.3&w=200',
  author4Src3:
    'https://images.unsplash.com/photo-1586297135537-94bc9ba060aa?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDMxfHxhdmF0YXJ8ZW58MHx8fHwxNzE2MzgzNTY2fDA&ixlib=rb-4.0.3&w=200',
  author2Src:
    'https://images.unsplash.com/photo-1566492031773-4f4e44671857?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDE1fHxhdmF0YXJ8ZW58MHx8fHwxNzE2MzgzNTUyfDA&ixlib=rb-4.0.3&w=200',
  author4Position3: undefined,
  author2Position: undefined,
  author4Src:
    'https://images.unsplash.com/photo-1586297135537-94bc9ba060aa?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDMxfHxhdmF0YXJ8ZW58MHx8fHwxNzE2MzgzNTY2fDA&ixlib=rb-4.0.3&w=200',
  author2Name: undefined,
  review42: undefined,
  author7Name: undefined,
  author7Position: undefined,
  author7Src: 'https://images.unsplash.com/photo-1604072360973-5fd38fd6de38?ixlib=rb-4.0.3&w=200',
  author7Alt: 'New AI Researcher',
  review7: undefined,
}

Team17.propTypes = {
  author1Alt: PropTypes.string,
  author4Name2: PropTypes.element,
  author4Src2: PropTypes.string,
  review3: PropTypes.element,
  author3Src: PropTypes.string,
  review1: PropTypes.element,
  author4Alt: PropTypes.string,
  author4Name: PropTypes.element,
  review2: PropTypes.element,
  review4: PropTypes.element,
  author3Alt: PropTypes.string,
  author4Name3: PropTypes.element,
  author4Position2: PropTypes.element,
  author1Position: PropTypes.element,
  author1Name: PropTypes.element,
  author4Alt2: PropTypes.string,
  heading1: PropTypes.element,
  author4Alt3: PropTypes.string,
  content1: PropTypes.element,
  rootClassName: PropTypes.string,
  author3Position: PropTypes.element,
  author2Alt: PropTypes.string,
  author3Name: PropTypes.element,
  author4Position: PropTypes.element,
  review43: PropTypes.element,
  author1Src: PropTypes.string,
  author4Src3: PropTypes.string,
  author2Src: PropTypes.string,
  author4Position3: PropTypes.element,
  author2Position: PropTypes.element,
  author4Src: PropTypes.string,
  author2Name: PropTypes.element,
  review42: PropTypes.element,
  author7Name: PropTypes.element,
  author7Position: PropTypes.element,
  author7Src: PropTypes.string,
  author7Alt: PropTypes.string,
  review7: PropTypes.element,
}

export default Team17